export class NewPurchase{
    constructor(
        public name: string,
        public supplier: string,
        public creator: string
    ){}
}